import { get, post } from './http'
import { pgMessage } from '../components/index'

/**
 * 循环获取rfid工作台读取的结果
 */
async function rfidInventory({ paramMethod, protocol }) {
  const [res, error] = await post(
    `${protocol}//localhost:${protocol === 'http:' ? '7000' : '7001'}/api/rfid/inventory`,
    paramMethod?.(),
    { errorTip: null }
  )
  if (error) {
    pgMessage.error(error?.msg || '接口无响应，请检查服务是否启动')
    return Promise.reject()
  }
  return res
}
/**
 * 开始启动rfid工作台
 */
export async function rfidWorkbenchStart({ paramMethod, delay = 1000, callback, second }) {
  const protocol = !second ? window.location.protocol : second
  const [res, error] = await get(
    `${protocol}//localhost:${protocol === 'http:' ? '7000' : '7001'}/api/rfid/start`,
    {},
    { errorTip: null }
  )
  if (!second && error) {
    return rfidWorkbenchStart({
      paramMethod,
      second: protocol === 'http:' ? 'https:' : 'http:',
    })
  }
  if (error || !res) {
    pgMessage.error(
      !res ? '连接失败，请检查设备是否已连接' : error?.msg || '接口无响应，请检查服务是否启动'
    )
    return Promise.reject()
  }
  pgMessage.success('已启动')

  let timer = null
  const task = async () => {
    const inventoryRes = await rfidInventory({ paramMethod, protocol })
    if (inventoryRes) {
      await callback(inventoryRes?.data ?? [])
      timer = setTimeout(task, delay)
    }
  }
  task()

  return {
    async close() {
      clearTimeout(timer)
      await get(
        `${protocol}//localhost:${protocol === 'http:' ? '7000' : '7001'}/api/rfid/stop`,
        {},
        { errorTip: null }
      )
      const inventoryRes = await rfidInventory({ paramMethod, protocol })
      if (inventoryRes) {
        await callback(inventoryRes?.data ?? [])
      }
      pgMessage.success('已停止')
    },
    async remove(epcs) {
      await post(
        `${protocol}//localhost:${protocol === 'http:' ? '7000' : '7001'}/api/rfid/clear`,
        { epcs },
        { errorTip: null }
      )
    },
  }
}
